import React, { useState, useEffect } from 'react';

export default function ConfigFunnelModal({ funnel, open, onClose, onSave }) {
  const [title, setTitle] = useState('');
  const [slug, setSlug] = useState('');
  const [description, setDescription] = useState('');
  const [headerScript, setHeaderScript] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // Update form fields when funnel prop changes
  useEffect(() => {
    if (funnel) {
      setTitle(funnel.title || '');
      setSlug(funnel.slug || '');
      setDescription(funnel.description || '');
      setHeaderScript(funnel.script || '');
    }
  }, [funnel]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    // Slug validator: only letters, numbers, _ and -, all lowercase, no spaces
    // On submit, clean and validate slug
    // Only allow lowercase letters, numbers, _ and -, no spaces, no ., ,, @, etc.
    const cleanedSlug = slug
      .toLowerCase()
      .replace(/\s+/g, '-') // replace spaces with -
      .replace(/[^a-z0-9_-]/g, ''); // remove all except a-z, 0-9, _ and -

    // Disallow if original slug contains any forbidden characters (including ., ,, @, etc.)
    if (cleanedSlug !== slug) {
      setSlug(cleanedSlug);
      setIsSaving(false);
      alert('O slug só pode conter letras minúsculas, números, "_" e "-". Não são permitidos caracteres como ".", ",", "@", etc. Espaços serão convertidos em "-".');
      return;
    }

    
    try {
      if (onSave) {
        await onSave({
          ...funnel,
          title,
          slug,
          description,
          script: headerScript,
          
        });
      }
      if (onClose) onClose();
    } catch (error) {
      console.error('Error saving funnel config:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
      style={{ backdropFilter: 'blur(2px)', zIndex: 10000 }}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 min-w-[350px] max-w-[95vw] w-full sm:w-[400px] relative">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl"
          onClick={onClose}
          aria-label="Fechar"
        >
          &times;
        </button>
        <h2 className="text-lg font-bold mb-4 text-gray-800">Configurações do Funil</h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Título do Funil</label>
            <input
              type="text"
              className="w-full border rounded px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-200"
              value={title}
              onChange={e => setTitle(e.target.value)}
               
              placeholder="Título do funil"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Slug</label>
            <div className="flex items-center">
              <span className="text-gray-500 bg-gray-100 border border-r-0 rounded-l px-3 py-2 text-sm select-none">
                https://hotify.ai/
              </span>
              <input
                type="text"
                className="w-full border rounded-r px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-200"
                value={slug}
                onChange={e => setSlug(e.target.value)}
                placeholder="ex: meu-funil"
                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
            <textarea
              className="w-full border rounded px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-200"
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={2}
              placeholder="Descrição do funil"
            />
          </div>
          <div  >
            <label className="block text-sm font-medium text-gray-700 mb-1">Script de Cabeçalho</label>
            <textarea
              className="w-full border rounded px-3 py-2 font-mono text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-200"
              value={headerScript}
              onChange={e => setHeaderScript(e.target.value)}
              rows={3}
              placeholder="Cole aqui scripts para o &lt;head&gt; (ex: pixel, analytics, etc)"
            />
          </div>
          <div className="flex items-center justify-between mt-2">
             
            <button
              type="submit"
              disabled={isSaving}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSaving && (
                <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12" cy="12" r="10"
                    stroke="currentColor" strokeWidth="4" fill="none"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  />
                </svg>
              )}
              {isSaving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
